import Icon from './Icon';

export default function LabeledField({ label, children, highlighted, onFocusCapture, hint }) {
  return (
    <div className="flex-1 flex flex-col gap-1" onFocusCapture={onFocusCapture}>
      <label className="text-2sm font-medium text-mono-600">{label}</label>
      <div className={`rounded-lg transition-all ${highlighted ? 'border border-orange-500 ring-1 ring-orange-500/20' : 'border border-transparent'}`}>
        {children}
      </div>
      {hint && (
        <div className="flex items-center gap-1">
          <Icon name="info" size={12} className="text-mono-400" />
          <span className="text-xs text-mono-400">{hint}</span>
        </div>
      )}
    </div>
  );
}
